module.exports = __webpack_public_path__ + "static/img/reChangJing6.5127ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reChangJing6.png
// module id = P78c
// module chunks = 2